import { createTestIds } from '../../utils';

export const getClassificationMarkingTestIds = createTestIds('classification-marking', [
  'top',
  'content',
  'bottom'
] as const);
